<template>
  <div>
    <section class="xbed-sub-title">
      <span>字典管理</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>IT 服务管理</BreadcrumbItem>
        <BreadcrumbItem>字典管理</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <br>
    <Tabs @on-click="changeTab">
      <TabPane label='字典组' name='dictionaryGroup'>
        <Form @submit.native.prevent="preventSubmit" inline>
          <FormItem label='字典组名称' :label-width='90' prop='keyWords'>
            <Input type="text" v-model="queryDictionaryGroup.keyWords"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="checkDictionaryGroup">查询</Button>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="addDictionGroupBtn">新增字典组</Button>
          </FormItem>
        </Form>
        <Content>
          <Table :columns="dictionaryGroupColumns" :data="dictionaryGroupList"></Table>
          <div style='margin:10px 0;overflow: hidden;'>
            <Page show-sizer placement='top' :total="dictionaryGroupTotal" :current="queryDictionaryGroup.page" :page-size="queryDictionaryGroup.size" @on-change="changePageGroup" @on-page-size-change="changePageSizeGroup"></Page>
          </div>
        </Content>
      </TabPane>
      <TabPane label='字典项' name='dictionaryItem'>
         <Form @submit.native.prevent="preventSubmit" inline>
          <FormItem label='字典组名称' :label-width='90' prop='keyWords'>
            <Select v-model="queryDictionaryItem.keyWords" filterable>
            <Option :value="-1">全部</Option>
            <Option v-for="(item,index) in selectDictionaryItem" :key="index" :value='item.id'>{{item.groupName}}</Option>
          </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="checkDictionaryItem">查询</Button>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="addDictionItemBtn">新增字典项</Button>
          </FormItem>
        </Form>
        <Content>
          <Table :columns="dictionaryItemColumns" :data="dictionaryItemList"></Table>
          <div style='margin:10px 0;overflow: hidden;'>
            <Page show-sizer placement='top' :total="dictionaryItemTotal" :current="queryDictionaryItem.page" :page-size="queryDictionaryItem.size" @on-change="changePageItem" @on-page-size-change="changePageSizeItem"></Page>
          </div>
        </Content>
      </TabPane>
    </Tabs>
    <!-- 字典组弹窗 -->
    <Modal v-model="dictionGroupDisplay" :title="dictionGroupTitle" ref="dictionGrouModal" :loading="true" @on-ok='dictionaryGroupOk'>
      <Form @submit.native.prevent="preventSubmit" :rules="dictionaryGroupRules" ref="dictionaryGroupForm">
        <FormItem label='字典组名称：（唯一）' :label-width='120' prop='dictionName'>
          <Input type="text" v-model="dictionGrouModal.dictionName"></Input>
        </FormItem>
        <FormItem label='字典组描述：' :label-width='120' prop='dictionDescribe'>
          <Input type='textarea' v-model="dictionGrouModal.dictionDescribe" :autosize="{minRows: 1,maxRows: 2}"></Input>
        </FormItem>
        <FormItem label='父字典组名称：' :label-width='120' prop='dictionParent'>
          <Select v-model="dictionGrouModal.dictionParent">
            <Option v-for="(item,index) in dictionaryGroupSelect" :key="index" :value='item.id'>{{item.groupName}}</Option>
          </Select>
        </FormItem>
        <FormItem label='是否可用：' :label-width='120' prop='dictionIsuse'>
          <RadioGroup  v-model="dictionGrouModal.dictionIsuse">
            <Radio :label='1'>是</Radio>
            <Radio :label='0'>否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <!-- 字典项弹窗 -->
    <Modal v-model="dictionItemDisplay" :title="dictionItemTitle" @on-ok='dictionaryItemOk' ref="dictionItemModal" :loading='true'>
      <Form @submit.native.prevent="preventSubmit" :rules='dictionaryItemRules' ref="dictionaryItemForm">
        <FormItem label='字典项名称（唯一）：' :label-width='120' prop='dictionItemName'>
          <Input type="text" v-model='dictionItemModal.dictionItemName'></Input>
        </FormItem>
        <FormItem label='字典值：' :label-width='120' prop='dictionaryValue'>
          <Input type="text" v-model='dictionItemModal.dictionaryValue'></Input>
        </FormItem>
        <FormItem label='字典组名称：' :label-width='120' prop='dictionItemParent'>
          <Select v-model="dictionItemModal.dictionItemParent">
            <Option v-for="item in dictionaryGroupSelect" :key="item.id" :value='item.id'>{{item.groupName}}</Option>
          </Select>
        </FormItem>
        <FormItem label='字典项描述：' :label-width='120' prop='dictionItemDescribe'>
          <Input type='textarea' v-model="dictionItemModal.dictionItemDescribe" :autosize="{minRows: 1,maxRows: 2}"></Input>
        </FormItem>
        <FormItem label='排序：' :label-width='120' prop='dictionItemSort'>
          <InputNumber v-model="dictionItemModal.dictionItemSort" style="width:200px;" :min="0"></InputNumber>
        </FormItem>
        <FormItem label='是否可用：' :label-width='120' prop='dictionItemIsuse'>
          <RadioGroup v-model="dictionItemModal.dictionItemIsuse">
            <Radio :label='1'>是</Radio>
            <Radio :label='0'>否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
export default {
  async created() {
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.headerENV = Utils.aliHeaderEnv(this.env)
  },
 async mounted() {
    this.$Notice.config({
			top: 100
		})
    this.queryGroupList()
  },
  data () {
    const validateDictionaryGroup = {
      dictionName: ( rule, value, callback ) => {
				if (!this.dictionGrouModal.dictionName) {
					callback( new Error( '字典组名称不能为空' ) )
				} else {
					callback();
				}
			},
      dictionDescribe: ( rule, value, callback ) => {
				if (!this.dictionGrouModal.dictionDescribe) {
					callback( new Error( '字典组描述不能为空' ) )
				} else {
					callback();
				}
			}
    }
    const validateDictionaryItem = {
      dictionItemName: ( rule, value, callback ) => {
				if (!this.dictionItemModal.dictionItemName) {
					callback( new Error( '字典项名称不能为空' ) )
				} else {
					callback();
				}
			},
      dictionaryValue: ( rule, value, callback ) => {
				if (!this.dictionItemModal.dictionaryValue) {
					callback( new Error( '字典值不能为空' ) )
				} else {
					callback();
				}
			},
      dictionItemParent: ( rule, value, callback ) => {
				if (this.dictionItemModal.dictionItemParent === 'S00') {
					callback( new Error( '字典组名称不能为空' ) )
				} else {
					callback();
				}
			},
      dictionItemDescribe: ( rule, value, callback ) => {
				if (!this.dictionItemModal.dictionItemDescribe) {
					callback( new Error( '字典项描述不能为空' ) )
				} else {
					callback();
				}
			},
      dictionItemSort: ( rule, value, callback ) => {
				if (this.dictionItemModal.dictionItemSort === '') {
					callback( new Error( '排序不能为空' ) )
				} else {
					callback();
				}
			},
    }
    return {
      // 字典组
      queryDictionaryGroup:{
        keyWords:'',
        page:1,
        size:10
      },
      dictionaryGroupList:[],
      dictionaryGroupTotal:0,
      dictionaryGroupSelect:[],
      dictionaryGroupColumns:[
        {
          title:'字典组id',
          key:'id',
          align:'center',
          width:100
        },
        {
          title:'字典组名称',
          key:'groupName',
          align:'center',
          width:300
        },
        {
          title:'字典组描述',
          key:'groupDesc',
          align:'center',
          width:500
        },
        {
          title:'父字典组名称',
          key:'parentGroupName',
          align:'center',
          width:300
        },
        {
          title:'是否可用',
          key:'isEnabled',
          align:'center',
          width:100,
          render:(h,params)=>{
            const isEnabled = params.row.isEnabled === 0 ? '否' : params.row.isEnabled === 1 ? '是' : '-'
            return h('div',{},isEnabled)
          }
        },
        {
          title:'操作',
          key:'id',
          align:'center',
          width:150,
          render:(h,params)=>{
            return h('div',[
              h('Button',{
                props:{
                  type:'primary',
                  size:'small'
                },
                style:{
                  margin:'3px'
                },
                on:{
                  click:()=>{
                    if ( !Utils.hasPermission( 'api_dictGroup_update' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    let data ={
                      seftId:params.row.id,
                      isTop:0
                    }
                    this.queryParentList(data)
                    this.dictionGrouModal = {
                      id:params.row.id,
                      dictionName:params.row.groupName,
                      dictionDescribe:params.row.groupDesc,
                      dictionParent:params.row.parentGroupId,
                      dictionIsuse:params.row.isEnabled
                    }
                    this.dictionGroupTitle = '字典组修改'
                    this.dictionGroupDisplay = true
                  }
                }
              },'修改'),
              h('Button',{
                props:{
                  type:'error',
                  size:'small'
                },
                style:{
                  margin:'3px'
                },
                on:{
                  click:()=>{
                    this.$Modal.confirm( {
                    title: "提示",
                    content: `确定删除<span style='color:red;margin:0 2px;'>${params.row.groupName}</span>吗？`,
                    okText: "确定",
                    cancelText: "取消",
                    onOk: () => {
                      this.cancelDictionGroup(params.row.id)
                    }
                  } );
                  }
                }
              },'删除')
            ])
          }
        },
      ],
      dictionGroupDisplay:false,
      dictionGroupTitle:'',
      dictionGrouModal:{
        dictionName:'',
        dictionDescribe:'',
        dictionParent:'S00',
        dictionIsuse:0
      },
      dictionaryGroupRules: {
				dictionName: [
					{required: true, validator: validateDictionaryGroup.dictionName, trigger: 'blur'}
				],
				dictionDescribe: [
					{required: true, validator: validateDictionaryGroup.dictionDescribe, trigger: 'blur'}
				]
			},
      // 字典项
      selectDictionaryItem:[],
      queryDictionaryItem:{
        keyWords:-1,
        page:1,
        size:10
      },
      dictionaryItemList:[],
      dictionaryItemTotal:0,
      dictionaryItemColumns:[
        {
          title:'字典项名称',
          key:'dictName',
          align:'center',
          width:300
        },
        {
          title:'字典项值',
          key:'dictValue',
          align:'center',
          width:100
        },
        {
          title:'字典组名称',
          key:'dictGroupName',
          align:'center',
          width:300
        },
        {
          title:'字典字典项描述',
          key:'dictDesc',
          align:'center',
          width:500
        },
        {
          title:'排序',
          key:'dictOrder',
          align:'center',
          width:100
        },
        {
          title:'是否可用',
          key:'isEnabled',
          align:'center',
          width:100,
          render:(h,params)=>{
            const isEnabled = params.row.isEnabled == 0 ? '否' : params.row.isEnabled == 1 ? '是' : '-'
            return h('div',{},isEnabled)
          }
        },
        {
          title:'操作',
          key:'id',
          align:'center',
          width:150,
          render:(h,params)=>{
            return h('div',[
              h('Button',{
                props:{
                  type:'primary',
                  size:'small'
                },
                style:{
                  margin:'3px'
                },
                on:{
                  click:()=>{
                    if ( !Utils.hasPermission( 'api_dictValue_update' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    let data ={
                      seftId:params.row.id,
                      isTop:0
                    }
                    this.queryParentList(data)
                    this.dictionItemModal = {
                      id:params.row.id,
                      dictionItemName:params.row.dictName,
                      dictionaryValue:params.row.dictValue,
                      dictionItemParent:params.row.dictGroupId,
                      dictionItemDescribe:params.row.dictDesc,
                      dictionItemSort:params.row.dictOrder,
                      dictionItemIsuse:params.row.isEnabled
                    }
                    this.dictionItemTitle = '字典项修改'
                    this.dictionItemDisplay = true
                  }
                }
              },'修改'),
              h('Button',{
                props:{
                  type:'error',
                  size:'small'
                },
                style:{
                  margin:'3px'
                },
                on:{
                  click:()=>{
                    this.$Modal.confirm( {
                    title: "提示",
                    content: `确定删除<span style='color:red;margin:0 2px;'>${params.row.dictName}</span>吗？`,
                    okText: "确定",
                    cancelText: "取消",
                    onOk: () => {
                      this.cancelDictionItem(params.row.id)
                    }
                  } );
                  }
                }
              },'删除')
            ])
          }
        },
      ],
      dictionItemDisplay:false,
      dictionItemTitle:'',
      dictionItemModal:{
        dictionItemName:'',
        dictionaryValue:'',
        dictionItemParent:'S00',
        dictionItemDescribe:'',
        dictionItemSort:0,
        dictionItemIsuse:0
      },
      dictionaryItemRules: {
				dictionItemName: [
					{required: true, validator: validateDictionaryItem.dictionItemName, trigger: 'blur'}
				],
				dictionaryValue: [
					{required: true, validator: validateDictionaryItem.dictionaryValue, trigger: 'blur'}
				],
				dictionItemParent: [
					{required: true, validator: validateDictionaryItem.dictionItemParent, trigger: 'blur'}
				],
				dictionItemDescribe: [
					{required: true, validator: validateDictionaryItem.dictionItemDescribe, trigger: 'blur'}
				],
				dictionItemSort: [
					{required: true, validator: validateDictionaryItem.dictionItemSort, trigger: 'blur'}
				],
			},
    }
  },
  methods: {
    changeTab(name){
      switch (name) {
        case 'dictionaryGroup':
          this.queryGroupList()
          break;
        case 'dictionaryItem':
          this.queryItemlist()
          break;
        default:
          break;
      }
    },
    // 字典组
    async queryGroupList(){
      if ( !Utils.hasPermission( 'api_dictGroup_list' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
      }
      let params = {
        groupName:this.queryDictionaryGroup.keyWords,
        pageNum:this.queryDictionaryGroup.page,
        pageSize:this.queryDictionaryGroup.size
      }
      const resp = (await API.omsAPI[this.env].clientServer.dictGroupList(params,{'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
      this.dictionaryGroupList = resp.list
      this.dictionaryGroupTotal = resp.total
    },
    checkDictionaryGroup(){
      this.queryGroupList()
    },
    changePageGroup(page){
      this.queryDictionaryGroup.page = page
      this.queryGroupList()
    },
    changePageSizeGroup(pageSize){
      this.queryDictionaryGroup.page = 1
      this.queryDictionaryGroup.size = pageSize
      this.queryGroupList()
    },
    // 获取父字典组名称-下拉框
    async queryParentList(data){
      const resp = (await API.omsAPI[this.env].clientServer.dictGroupTopList(data, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      this.dictionaryGroupSelect = resp
    },
    // 新增
    async addDictionGroupBtn(){
      if ( !Utils.hasPermission( 'api_dictGroup_add' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
      let params ={
        seftId:'',
        isTop:1
      }
      this.queryParentList(params)
      this.dictionGrouModal = {
        dictionName:'',
        dictionDescribe:'',
        dictionParent:'S00',
        dictionIsuse:0
      },
      this.dictionGroupTitle = '新增字典组'
      this.dictionGroupDisplay = true
    },
    async dictionaryGroupOk(){
      let validResult = false;
			this.$refs.dictionaryGroupForm.validate( valid => {
				validResult = valid
      });
			if (!validResult) {
				this.$refs.dictionGrouModal.buttonLoading = false;
				return;
			}
      if (this.dictionGrouModal.id) {
        let params = {
          id:this.dictionGrouModal.id,
          groupName:this.dictionGrouModal.dictionName,
          parentId:this.dictionGrouModal.dictionParent === 'S00' ? '':this.dictionGrouModal.dictionParent,
          groupDesc:this.dictionGrouModal.dictionDescribe,
          isEnabled:this.dictionGrouModal.dictionIsuse,
          updateName:this.username,
        }
        const resp = (await API.omsAPI[this.env].clientServer.dictGroupUpdate(params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
          if(resp.retCode){
            this.$Notice.error({
              title: '修改失败',
              desc: resp.msg
            })
            this.$refs.dictionGrouModal.buttonLoading = false;
            return
          }
          this.$Notice.success({
            title: '修改成功',
            desc: resp.msg
          })
      } else {
        let params = {
          groupName:this.dictionGrouModal.dictionName,
          parentId:this.dictionGrouModal.dictionParent === 'S00' ? '':this.dictionGrouModal.dictionParent,
          groupDesc:this.dictionGrouModal.dictionDescribe,
          isEnabled:this.dictionGrouModal.dictionIsuse,
          createName:this.username,
        }
        const resp = (await API.omsAPI[this.env].clientServer.dictGroupInsert(params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
          if(resp.retCode){
            this.$Notice.error({
              title: '新增失败',
              desc: resp.msg
            })
            this.$refs.dictionGrouModal.buttonLoading = false;
            return
          }
          this.$Notice.success({
            title: '新增成功',
            desc: resp.msg
          })
      }
      this.queryGroupList()
      this.dictionGroupDisplay = false
    },
    async cancelDictionGroup(id){
      if ( !Utils.hasPermission( 'api_dictGroup_delete' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
      const resp = (await API.omsAPI[this.env].clientServer.dictGroupDelete({id:id,updateName:this.username}, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '删除失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
          title: '删除成功',
          desc: resp.msg
      })
      this.queryGroupList()
    },
    /**---------------------------------------------------字典项------------------------------------------------------------*/ 
    async queryItemlist(){
      if ( !Utils.hasPermission( 'api_dictValue_list' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      // 查询字典组名称select
      const respSele = (await API.omsAPI[this.env].clientServer.dictGroupList({pageNum:1,pageSize:999999,groupName:''}, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      this.selectDictionaryItem = respSele.list
      // 列表
      let params = {
        pageNum:this.queryDictionaryItem.page,
        pageSize:this.queryDictionaryItem.size,
        groupId:this.queryDictionaryItem.keyWords === -1 ? '' : this.queryDictionaryItem.keyWords
      }
      const resp = (await API.omsAPI[this.env].clientServer.dictValueList(params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
      this.dictionaryItemList = resp.list
      this.dictionaryItemTotal = resp.total
    },
    checkDictionaryItem(){
      this.queryItemlist()
    },
    changePageItem(page){
      this.queryDictionaryItem.page = page
      this.queryItemlist()
    },
    changePageSizeItem(size){
      this.queryDictionaryItem.page = 1
      this.queryDictionaryItem.size = size
      this.queryItemlist()
    },
    // 新增
    addDictionItemBtn(){
      if ( !Utils.hasPermission( 'api_dictValue_add' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
      let params ={
        seftId:'',
        isTop:0
      }
      this.queryParentList(params)
      this.dictionItemModal = {
        dictionItemName:'',
        dictionaryValue:'',
        dictionItemParent:'S00',
        dictionItemDescribe:'',
        dictionItemSort:0,
        dictionItemIsuse:0
      }
      this.dictionItemTitle = '新增字典项'
      this.dictionItemDisplay = true
    },
    async dictionaryItemOk(){
      let validResult = false;
			this.$refs.dictionaryItemForm.validate( valid => {
				validResult = valid
      });
			if (!validResult) {
				this.$refs.dictionItemModal.buttonLoading = false;
				return;
      }
      if (this.dictionItemModal.id) {
        let params = {
          id:this.dictionItemModal.id,
          dictName:this.dictionItemModal.dictionItemName,
          dictValue:this.dictionItemModal.dictionaryValue,
          dictGroupId:this.dictionItemModal.dictionItemParent === 'S00' ? '':this.dictionItemModal.dictionItemParent,
          dictDesc:this.dictionItemModal.dictionItemDescribe,
          dictOrder:this.dictionItemModal.dictionItemSort,
          isEnabled:this.dictionItemModal.dictionItemIsuse,
          updateName:this.username,
        }
        const resp = (await API.omsAPI[this.env].clientServer.dictValueUpdate(params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
          if(resp.retCode){
            this.$Notice.error({
              title: '修改失败',
              desc: resp.msg
            })
            this.$refs.dictionItemModal.buttonLoading = false;
            return
          }
          this.$Notice.success({
            title: '修改成功',
            desc: resp.msg
          })
      } else {
         let params = {
          dictName:this.dictionItemModal.dictionItemName,
          dictValue:this.dictionItemModal.dictionaryValue,
          dictGroupId:this.dictionItemModal.dictionItemParent === 'S00' ? '':this.dictionItemModal.dictionItemParent,
          dictDesc:this.dictionItemModal.dictionItemDescribe,
          dictOrder:this.dictionItemModal.dictionItemSort,
          isEnabled:this.dictionItemModal.dictionItemIsuse,
          createName:this.username,
        }
        const resp = (await API.omsAPI[this.env].clientServer.dictValueInsert(params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
          if(resp.retCode){
            this.$Notice.error({
              title: '新增失败',
              desc: resp.msg
            })
            this.$refs.dictionItemModal.buttonLoading = false;
            return
          }
          this.$Notice.success({
            title: '新增成功',
            desc: resp.msg
          })
      }
      this.queryItemlist()
      this.dictionItemDisplay = false
    },
    async cancelDictionItem(id){
      if ( !Utils.hasPermission( 'api_dictValue_delete' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
      const resp = (await API.omsAPI[this.env].clientServer.dictValueDelete({id:id,updateName:this.username}, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '删除失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
          title: '删除成功',
          desc: resp.msg
      })
      this.queryItemlist()
    },
    preventSubmit(){
      return false;
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/smart-device/dictionary-managed/index.vue